import axios from 'axios';
export const KMSAccessToken = 'kms_access_token';
import { client } from 'api';
import { API_URL } from '../../config';

const Authentication = {
  signOut() {
    client.clearStore();
    localStorage.setItem(KMSAccessToken, '');
    window.location.href = '/login';
    // @ts-ignore
    window.location.reload(true);
  },
  signIn(token: string) {
    localStorage.setItem(KMSAccessToken, token);
  },
  getToken() {
    return localStorage.getItem(KMSAccessToken);
  },
  async isAuthenticated() {
    const token = this.getToken();
    if (token) {
      return axios({
        url: `${API_URL}/authentication/verify`,
        method: 'POST',
        headers: {
          'X-Access-Token': token
        }
      });
    }

    return !!token;
  }
};

export default Authentication;
